export class CreateUser {
  email!: string 
  name!: string 
  gender!: string 
  phone!: string | null  // valide + on number
  identificationNumber!: string  // valide cpf
  internalCode!: string
  physicianIdentificationNumber!: string
  physicianState!: string
  recoveryEmail!: string | null
  birthdate!: Date | null
  poolId!: string
  password!: string
  isPasswordTemporary: boolean = false

  constructor(user: any) {
    this.email = user.email
    this.name = user.name
    this.gender = user.gender
    this.phone = user.phone && user.phone.length !== 0 ? `+${user.phone.replace(/[^a-zA-Z0-9]/g, '')}` : null;
    this.identificationNumber = user.identificationNumber && user.identificationNumber.length !== 0 ? user.identificationNumber?.replace(/[^a-zA-Z0-9]/g, '') : null;
    this.internalCode = user.internalCode && user.internalCode.length !== 0 ? user.internalCode : null
    this.physicianIdentificationNumber = user.physicianIdentificationNumber && user.physicianIdentificationNumber.length !== 0 ? user.physicianIdentificationNumber : null
    this.physicianState = user.physicianState && user.physicianState.length !== 0 ? user.physicianState : null
    this.recoveryEmail = user.recoveryEmail && user.recoveryEmail.length !== 0 ? user.recoveryEmail : null
    this.birthdate = user.birthdate && (typeof user.birthdate === 'string' ? user.birthdate.length !== 0 : true) ? user.birthdate : null
    this.poolId = user.poolId
    this.password = user.password
    this.isPasswordTemporary = user.isPasswordTemporary ?? false;
  }
}